import { apiClient } from '@/shared/api'

import { TEditorPickArticle } from '../model/schema'

type Props = {
  type: 'guest' | 'host'
}

export const getEditorPickArticles = async ({ type }: Props) => {
  const { data } = await apiClient.get<TEditorPickArticle[]>({
    endpoint: `/campaigns/articles/editor-pick/${type}`,
  })

  return data
}
